// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"179":"a324c8ad","488":"a53988cc","684":"600b3371","728":"9674cfda","979":"489ebae2"}[chunkId] + ".chunk.js";
};